import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {
    fetchStatisticsList,
    getStatisticsExcel,
    changeCurrentPath,
    resetStatisticsListStatus,
    resetStatisticsStatus,
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ReloadModal from '../../common/components/dialog/reload-dialog';
import ErrorDialog from '../../common/components/dialog/error-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

import MainButtons from '../../common/components/main-buttons';
import Table from '../../common/components/table/common-table';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';



const styles = theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontFamily:'Noto Sans JP'
    },
    expands : {
        boxShadow:'initial'
    },
    conditionTitle:{
        fontFamily:'Noto Sans JP',
        fontWeight:400,
        display:'inline-block',
        width:250,
        color:'rgba(0,0,0,0.87)'
    },
    conditionDivide:{
        display:'inline-block',
        marginRight:15,
    }
});


class StatisticsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            IsLogin : false,
            IsProcess : false,
        };

        this.nextIsStatistics = false;
    }
	/** override methods **/
    UNSAFE_componentWillMount() {
        const {dispatch, settings} = this.props;
        dispatch(fetchStatisticsList({data:settings.currentFormValues}));
	}

    /** override methods **/
	componentDidMount() {
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}

    componentWillUnmount() {
        this.props.dispatch(resetStatisticsListStatus());
        if(!this.nextIsStatistics){
            this.props.dispatch(resetStatisticsStatus());
        }
    }

    /** event handlers **/
    handleClickDL = () =>{
        const {dispatch, settings, auth} = this.props;

        dispatch(getStatisticsExcel({
            SessionID : auth.SessionID,
            data : settings.outputData,
            columns : settings.outputColumn,
            numberColumns : settings.numberColumns,
            conditions : settings.conditions
        }));
    };

    handleClickBack = () =>{
        this.nextIsStatistics = true;
        this.props.history.push('/statistics');
    };


    render() {
        const {settings, classes} = this.props;
        const {isFetching, outputData, outputColumn, numberColumns, conditions} = settings;

        const disabled = (outputData.length === 0);

        const mainButtons = [
            {type:'DL',func:this.handleClickDL,disabled:disabled, text:'Excel'},
            {type:'BACK',func:this.handleClickBack,text:"戻る"}
        ];

        return (
            <div id="main_container">
                {isFetching &&
                <Progress/>
                }
                <SpNav history={this.props.history}/>
                <Header history={this.props.history}/>
                <article>
                    <section className="title_area">
                        <h2>統計出力結果</h2>
                    </section>
                    <ExpansionPanel defaultExpanded className={classNames("with_button condition_area",classes.expands)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                            <Typography className={classes.heading}>設定抽出条件</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <div>
                            {conditions.map((row,index)=>{
                                return(
                                    <Typography key={index}>
                                        <span className={classes.conditionTitle}>{row.title}</span>
                                        <span className={classes.conditionDivide}>:</span>
                                        {row.value}
                                    </Typography>
                                )
                            })}
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <section className="with_button">
                        {outputColumn.length > 0 &&
                        <Table
                            dataSource={outputData}
                            columns={outputColumn}
                            numberColumns={numberColumns}
                            defaultSorts={[{columnName:'id',direction:'asc'}]}
                            hasSelections={false}
                        />
                        }
                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                <ErrorDialog
                    open={this.props.settings.isProcessError}
                />
				<ReloadModal />
                <LogoutModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth,
      settings : state.statisticsListSettings,

  };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(StatisticsList);



// WEBPACK FOOTER //
// ./src/routes/statistics-list/index.js